// mainタグにp-topクラスが付いているかを確認
const mainElement = document.querySelector("main.p-topics");

if (mainElement) {
  const selectBox = document.querySelector("#archives-dropdown");
  const selectWrapper = document.querySelector(".p-topics-search__select");
  document
    .getElementById("archives-dropdown")
    .addEventListener("change", function () {
      const url = this.value;
      if (url) {
        window.location.href = url; // 選択されたURLにリダイレクト
      }
    });
  selectBox.addEventListener("focus", () => {
    selectWrapper.classList.add("open");
  });

  selectBox.addEventListener("blur", () => {
    selectWrapper.classList.remove("open");
  });
}
